import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import makeRequest from "./makeRequest"

const generateApiSliceAndThunk = (
  sliceName: string,
  endpoint: string,
  method: string
) => {
  const initialState = {
    data: null as any,
    loading: false,
    error: null as string | null,
    success: false,
  }

  const request = createAsyncThunk<any, Record<string, any>>(
    `${sliceName}/request`,
    async (params: Record<string, any>, { rejectWithValue }) => {
      try {
        const response = await makeRequest(endpoint, method, params)
        return response
      } catch (error: any) {
        return rejectWithValue(error?.message || "Something went wrong")
      }
    }
  )

  const slice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
      reset: state => {
        state.data = null
        state.loading = false
        state.error = null
        state.success = false
      },
      update: (state, action) => {
        state.data = action.payload
      },
    },
    extraReducers: builder => {
      builder
        .addCase(request.pending, state => {
          state.loading = true
          state.error = null
          state.success = false
        })
        .addCase(request.fulfilled, (state, action) => {
          state.loading = false
          state.data = action.payload
          state.success = true
          state.error = action.payload?.errors || null
        })
        .addCase(request.rejected, (state, action) => {
          state.loading = false
          state.success = false
          state.error = action.payload as string
        })
    },
  })

  return {
    slice,
    request,
  }
}

export default generateApiSliceAndThunk
